import React from 'react';
import { ReactQueryProvider } from '@/utils/ReactQuery';
import Text from '@/components/ui/Text';
import SPADataTable from '@/components/admin/SysadminSPA/shared/SPADataTable';
import { SPAThemeScope } from '@/components/admin/SysadminSPA/shared/SPAThemeScope';
import { LEGACY_THEME_CLASS, legacyGroundClass } from '@/components/admin/PrintToolsPage';
import getAuditLogColumns from './auditLogColumns';
import useSubscriberVersions from './useSubscriberVersions';

interface AuditLogProps {
  subscriberId: number;
}

const DEFAULT_SORT = [{ desc: true, id: 'changedAt' }];

// AIDEV-NOTE: The subscriber change log (PLAT-18103), the legacy sysadmin Audit Log page. The table is
// the SPA's, pinned to the light tokens the way PrintToolsPage does.
const AuditLog = ({ subscriberId }: AuditLogProps) => {
  const {
    isFullyLoaded, isLoading, rows, totalCount,
  } = useSubscriberVersions(subscriberId);

  return (
    <div>
      <Text className="tw-text-very-dark-grey" size="sm">
        Every change to this subscriber, whoever made it. A change made while impersonating an admin is
        attributed to the TCI staff member.
      </Text>

      <SPAThemeScope className={LEGACY_THEME_CLASS}>
        <div className={legacyGroundClass}>
          <div className="tw-mt-4">
            <SPADataTable
              columns={getAuditLogColumns()}
              data={rows}
              defaultSort={DEFAULT_SORT}
              emptyMessage="No changes recorded yet."
              globalFilter={{ placeholder: 'Search the log...' }}
              isLoading={isLoading}
              loadingRows={10}
              loadingStatus={{ isFullyLoaded, loadedCount: rows.length, totalCount }}
              pagination={{ defaultPageSize: 25, pageSizeOptions: [25, 50, 100] }}
            />
          </div>
        </div>
      </SPAThemeScope>
    </div>
  );
};

const AuditLogWrapper = (props: AuditLogProps) => (
  <ReactQueryProvider>
    <AuditLog {...props} />
  </ReactQueryProvider>
);

export default AuditLogWrapper;
